import ProgressBarTab from './Tab';
import useProgressBar from './useProgressBar';

export type ProgressBarSingleStep = {
  type: 'single';
  url: string | string[];
};

export type ProgressBarMultiStep = {
  type: 'multi';
  urls: (ProgressBarSingleStep | ProgressBarMultiStep)[];
};

export type ProgressBarStep = ProgressBarSingleStep | ProgressBarMultiStep;

export interface ProgressBarProps {
  steps: ProgressBarStep[];
}

const ProgressBar: React.FunctionComponent<ProgressBarProps> = function ({
  steps,
}) {
  const { tabs } = useProgressBar(steps);
  return (
    <div className="flex flex-row gap-x-1 bg-neutral-000">
      {tabs.map((tab) => (
        <ProgressBarTab tab={tab} key={tab.index} />
      ))}
    </div>
  );
};

export default ProgressBar;
